module.exports = __webpack_public_path__ + "643a6d68ae1b6f2fbad237a38a6099ef.svg";